/**
 * @generated SignedSource<<f829963c827e73ddfbc27c6788940676>>
 * @relayHash e72cea2ac8cb40f73f08d8ae16d4f2bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3bd9f4a5c012ec5e3c61663d66576fcbb2608ae32decce798a6ac0159b5e111

import type { ConcreteRequest, Query } from 'relay-runtime';
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$variables = {
  cloudId: string;
  container: string;
  isEnabled: boolean;
};
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$data = {
  readonly knowledgeBase?: {
    readonly knowledgeBase: {
      readonly __typename: "KnowledgeBaseSources";
      readonly edge: ReadonlyArray<{
        readonly node: {
          readonly sourceType: string;
        };
      } | null | undefined>;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery = {
  response: knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$data;
  variables: knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "container"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "container",
    "variableName": "container"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "sourceType"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "KnowledgeBaseQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "knowledgeBase",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "KnowledgeBaseSourceEdge",
                          "kind": "LinkedField",
                          "name": "edge",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "KnowledgeBaseSource",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": (v4/*: any*/),
                                  "action": "THROW",
                                  "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                                }
                              ]
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "knowledgeBase.knowledgeBase.edge"
                      }
                    ],
                    "type": "KnowledgeBaseSources"
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "KnowledgeBaseQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "knowledgeBase",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSourceEdge",
                        "kind": "LinkedField",
                        "name": "edge",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "KnowledgeBaseSource",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeBaseSources"
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c3bd9f4a5c012ec5e3c61663d66576fcbb2608ae32decce798a6ac0159b5e111",
    "metadata": {},
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5b37546d5291f5fef61c0f9513ec0455";

export default node;
